<template>
  <div>
    <job-header-simple header_title="申请开票" left_text="" :part_background="true"></job-header-simple>
    <div class="header">
    </div>
    <div class="invoice">
        <van-cell title="发票抬头" is-link :value="invoiceTitle" @click="chooseInvoiceTitle" :value-class="{'choose-value':blackTitle}"/>
        <van-cell title="开票公司" is-link :value="ecompanyName" @click="chooseEcompany" :value-class="{'choose-value':blackEcompany}"/>
        <van-cell title="操作类型" is-link :value="invoiceTypeName" @click="chooseInvoiceType" :value-class="{'choose-value':blackInvoiceType}"/>
        <van-cell title="用工类型" is-link :value="typeName" @click="chooseType" :value-class="{'choose-value':blackType}"/>
        <van-cell title="发票类型" is-link :value="invoiceType" :value-class="{'choose-value':blackInvoice}"/>
        <van-cell title="发票内容" is-link :value="contentName" @click="chooseContent" :value-class="{'choose-value':blackContent}"/>

        <div class="button">
          <van-button color="#6275f0" @click="apply">申请开票</van-button>
        </div>
        <van-action-sheet v-model="showTitle" :round="false" :actions="actions" @select="selectEcompany"/>
        <van-action-sheet v-model="showInvoiceType" :round="false" :actions="invoiceTypeData" @select="selectInvoiceType"/>
        <van-action-sheet v-model="showType" :round="false">
          <div class="show-type">
            <div class="choose">
              <div class="cancel"  @click="showType=false">取消</div>
              <div class="confirm" @click="showType=false">确定</div>
            </div>
            <van-checkbox-group v-model="result" >
            <van-cell-group>
              <van-cell
                v-for="item in typeList"
                clickable
                :key="item.id"
                :title="`${item.name}`"
                @click="chooseItem(item)"
              >
                <template #right-icon>
                  <van-checkbox :name="item"/>
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
          </div>
        </van-action-sheet>
        <van-action-sheet v-model="showContent" :round="false" :actions="content" @select="selectContent"/>
    </div>
  </div>
</template>
<script>
import { Row,Col,Icon,Cell,CellGroup,Divider,ActionSheet,Checkbox, CheckboxGroup,Button } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";

export default {
  components: {
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [ActionSheet.name]: ActionSheet,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    jobHeaderSimple
  },
  created() {
    if (this.$route.query.name&&this.$route.query.id) {
      this.invoiceTitle = this.$route.query.name;
      this.ecompanyId = this.$route.query.id;
      this.blackTitle = true;
      //如果外派公司只有一种开票类型默认选中
        api.getEcompanyInvoiceTypeById({ id: this.ecompanyId }).then(res => {
            if (res.data.status == "200") {
                if (res.data!= null) {
                    this.invoiceTypeData = res.data.data;
                    if(this.invoiceTypeData.length == 1){
                        this.invoiceTypeName = this.invoiceTypeData[0].name;
                        this.invoiceTypeValue = this.invoiceTypeData[0].value;
                        this.blackInvoiceType = true;
                    }
                }
            }
        });
    }
    // 页面跳转回来获取session数据
    let openInvoiceData = JSON.parse(sessionStorage.getItem("openInvoice"));
    if (openInvoiceData) {
      this.invoiceTitle =  openInvoiceData.invoiceTitle;
      this.ecompanyName = openInvoiceData.ecompanyName;
      this.invoiceTypeName =  openInvoiceData.invoiceTypeName;
      this.invoiceTypeValue = openInvoiceData.invoiceTypeValue;
      this.typeName = openInvoiceData.typeName;
      this.contentName = openInvoiceData.contentName;
      this.jobCategoryids = openInvoiceData.jobCategoryids;
      this.ecompanyId = openInvoiceData.ecompanyId;
      this.companyId = openInvoiceData.companyId;
      this.contentId = openInvoiceData.contentId;
      this.receiptType = openInvoiceData.receiptType;
      this.invoiceType = openInvoiceData.invoiceType;
      this.invoiceTypeId =  openInvoiceData.invoiceTypeId;
      this.blackTitle = true;
      this.blackEcompany  = true;
      this.blackInvoiceType  = true;
      this.blackType = true;
      this.blackContent = true;
      this.blackInvoice = true;
      sessionStorage.removeItem('openInvoice');
    }
  },
  data() {
    return {
      showTitle: false,
      showInvoiceType: false,
      showType: false,
      showContent: false,
      // chooseTitle chooseEcompany chooseType chooseTypeContent
      invoiceTitle: '请选择发票抬头',
      blackTitle: false,
      ecompanyId: '', //ecompanyId
      ecompanyName: '请选择开票公司',
      invoiceTypeName: '请选择操作类型',
      invoiceTypeValue: '',
      blackEcompany: false,
      blackInvoiceType: false,
      companyId: '', //ocompanyId
      typeName: '请选择用工类型',
      blackType: false,
      jobCategoryids: '',
      receiptType:'',
      contentName:'请选择发票内容',
      blackContent: false,
      invoiceType:'请选择发票类型',
      invoiceTypeId:'',
      blackInvoice: false,
      contentId:'',
      actions: [],
      invoiceTypeData: [],
      typeList: [],
      result: [],
      content: [],
      invoices:[],
      invoiceTypeArray:[]
    };
  },
  methods: {
    chooseEcompany(){
      if (!this.ecompanyId) {
        this.$toast({
          message: "请选择发票抬头!",
        });
        return
      }
      if (this.actions.length==0) {
        api.applySelect({ ecompanyId: this.ecompanyId }).then(res => {
          if (res.data.status == "200") {
            this.actions = res.data.data;
            this.showTitle = true;
          }
        });
      }else{
        this.showTitle = true;
      }
    },
    //获取外派公司的开票类型
    chooseInvoiceType(){
      if (!this.ecompanyId) {
          this.$toast({
              message: "请选择发票抬头!",
          });
          return
      }
        api.getEcompanyInvoiceTypeById({ id: this.ecompanyId }).then(res => {
          if (res.data.status == "200") {
              if (res.data!= null) {
                  this.invoiceTypeData = res.data.data;
                  this.showInvoiceType = true;
              }
          }else {
              this.$toast({
                  message: res.data.message,
              });
          }
        });
    },
    chooseInvoiceTitle(){
      this.$router.push({ path: "choose_invoice_title",query: { canclick: true} });
    },
    chooseType(){
      if (!this.ecompanyId) {
        this.$toast({
          message: "请选择发票抬头!",
        });
        return
      }
	    
	  if(!this.companyId){
	  this.$toast({
		message: "请选择开票公司!",
	  });
	  return
	  }
	  
      if (this.typeList.length==0) {
        api.applyType({ ecompanyId: this.ecompanyId }).then(res => {
          if (res.data.status == "200") {
            this.showType = true;
            this.typeList = res.data.data;
          }
        });
      }else{
        this.showType = true;
      }
    },
    getInvoiceType(){
      let sameType = true;
      // 所有类型对应的发票类型都一样后才能选择
      let receiptType = this.invoiceTypeArray[0];
      this.invoiceTypeArray.forEach(id=>{
        if (receiptType !== id) {
          sameType = false;
        }
      });
      if(!sameType){ //无符合条件的发票类型
        this.blackInvoice = true;
        this.invoiceType = '无符合条件的发票类型';
        this.invoiceTypeId = '';
        this.invoices = [];
        return;
      }
      if (this.invoices.length==0) {
        this.invoices = [];
        api.receiptTypeGroup().then(res => {
          if (res.data.status == "200") {
            this.invoices = res.data.data;
            this.forEachInvoice(receiptType);
          }
        });
      }else{
        this.forEachInvoice(receiptType);
      }
    },
    forEachInvoice(receiptType){
      this.invoices.forEach(element=>{
        if (receiptType== element.code) {
          this.invoiceType = element.value;
          this.invoiceTypeId = element.code;
          this.blackInvoice = true;
        }
      })
    },
    chooseContent(){
      if (!this.jobCategoryids) {
        this.$toast({
          message: "请选择用工类型!",
        });
        return
      }
      this.content = [];
      api.applyContent({ jobCategoryids: this.jobCategoryids , ocompanyId: this.companyId}).then(res => {
        if (res.data.status == "200") {
          if (res.data.data) {
            this.showContent = true;
            res.data.data.forEach(element=>{
              let item = {};
              /*
              * ready be executed yanxiaofei
              * item.id=element.id;
              * item.name=element.content;
              * this.content.push(item);
              * */
              item.name = element.content;
              item.id = element.id;
              this.content.push(item);
            })
          }else{
            this.contentName = "无符合条件的发票内容!";
            this.blackContent = true;
          }
        }
      });
    },
    getType() {
      let typeArray = [];
      let categoryArray = [];
      this.invoiceTypeArray = [];
      if (this.result.length>0) {
        this.result.forEach(element => {
          this.receiptType = element.receiptType;
          typeArray.push(element.name);
          categoryArray.push(element.id);
          this.invoiceTypeArray.push(element.receiptType);
        });
        this.typeName = typeArray.join(',');
        this.blackType = true;
        this.jobCategoryids = categoryArray.join(',');
      }else{
        this.typeName = '请选择用工类型';
        this.jobCategoryids = '';
        this.blackType = false;
      }
    },
    chooseItem(item){
      let index = this.result.indexOf(item);
      this.contentName='请选择发票内容';
      this.contentId = '';
      this.blackContent = false;
      if (index==-1) {
        this.result.push(item);
      }else{
        this.result.splice(index,1);
      }
      // 重置发票类型和发票内容
      this.getType();
      if (this.result.length>0) {
        this.getInvoiceType();
      }else{
        this.blackInvoice = false;
        this.invoiceType = '请选择发票类型';
        this.invoiceTypeId = '';
        this.invoices = [];
      }
    },
    selectEcompany(item) {
      this.showTitle = false;
      this.ecompanyName = item.name;
      this.companyId = item.id;
      this.blackEcompany = true;
    },
    selectInvoiceType(item) {
      this.showInvoiceType = false;
      this.invoiceTypeName = item.name;
      this.invoiceTypeValue = item.value;
      this.blackInvoiceType = true;
    },
    selectContent(content){
      this.showContent = false;
      this.contentName = content.name;
      this.contentId = content.id;
      this.blackContent = true;
    },
    selectInvoice(invoice){
      this.invoiceType = invoice.name;
      this.invoiceTypeId = invoice.id;
      this.blackInvoice = true;
    },
    apply(){
      if(!this.ecompanyId) {
        this.$toast({
          message: "请选择发票抬头!",
        });
        return
      }
      if(!this.companyId) {
        this.$toast({
          message: "请选择开票公司!",
        });
        return
      }
      if(!this.invoiceTypeValue) {
        this.$toast({
          message: "请选择操作类型!",
          });
        return
      }
      if(!this.jobCategoryids) {
        this.$toast({
          message: "请选择用工类型!",
        });
        return
      }
      if(!this.invoiceTypeId) {
        this.$toast({
          message: "请选择发票类型!",
        });
        return
      }
      if(!this.contentId) {
        this.$toast({
          message: "请选择发票内容!",
        });
        return
      }
      let openInvoiceData = {};
      openInvoiceData.invoiceTitle = this.invoiceTitle;
      openInvoiceData.ecompanyName = this.ecompanyName;
      openInvoiceData.invoiceTypeName = this.invoiceTypeName;
      openInvoiceData.invoiceTypeValue = this.invoiceTypeValue;
      openInvoiceData.typeName = this.typeName;
      openInvoiceData.contentName = this.contentName;
      openInvoiceData.invoiceType = this.invoiceType;
      openInvoiceData.invoiceTypeId = this.invoiceTypeId;
      openInvoiceData.jobCategoryids = this.jobCategoryids;
      openInvoiceData.ecompanyId = this.ecompanyId;
      openInvoiceData.companyId = this.companyId;
      openInvoiceData.contentId = this.contentId;
      openInvoiceData.receiptType = this.receiptType;
      openInvoiceData =  JSON.stringify(openInvoiceData);
      sessionStorage.setItem("openInvoice", openInvoiceData);
      if(this.invoiceTypeValue=='priority_invoice'){//授信开票
          this.$router.push({
              path: "credit_invoice",
              query: {
                  ecompanyId: this.ecompanyId,
                  ocompanyId: this.companyId,
                  // receiptType: this.receiptType,
                  // contentId: this.contentId,
                  // jobCategoryIds: this.jobCategoryids
              }
          });
      } else {//充值开票
          this.$router.push({
              path: "choose_invoice_data",
              query: {
                  ecompanyId: this.ecompanyId,
                  ocompanyId: this.companyId,
                  receiptType: this.receiptType,
                  contentId: this.contentId,
                  jobCategoryIds: this.jobCategoryids
              }
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.header{
    width: 100%;
    height: 3.46rem;
    background-color: #6275f0;
}
.invoice{
  width: 90%;
	height: 12.6rem;
  overflow-y: scroll;
  margin: -2.88rem auto 0;
	background-color: #ffffff;
	border-radius: 12px;
  position: relative;
  padding: 0.2rem;
  .show-type{
    width: 100%;
    min-height: 4rem;
    .choose{
      display: flex;
      justify-content: space-between;
      padding: 0.4rem;
      font-size: 0.37333rem;
      .cancel {
        color: #969799  
      }
      .confirm{
         color: #6275f0  
      }
    }
  }
  .van-action-sheet__content {
    padding-bottom: 2rem;
  }
  /deep/ .van-cell__title{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }
  /deep/ .van-cell__value{
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    text-align: left;
  }
  .choose-value{
    color: #323233;
  }
  .button{
    position: absolute;
    bottom: 1.38rem;
    left:50%;
    transform:translate(-50%,0);
    .van-button{
      width: 6rem;
      height: 1rem;
      background-color: #6275f0;
      border-radius: 1rem;
      font-size: 0.37rem;
    }
  }
}
</style>